export default "__VITE_PUBLIC_ASSET__00be40c7__"